import { FC, HTMLAttributes } from 'react';

import { Calendar, Flex } from 'antd';
import cn from 'classnames';
import dayjs from 'dayjs';

import { EFilters, useFilters } from 'features/Filters';
import { PlannerPost, PlannerPostResponse, usePlannerDates } from 'features/Planner';
import { formatDate } from 'shared/utils';

import 'dayjs/locale/ru';

import styles from './PlannerYear.module.scss';
dayjs.locale('ru');

interface IPlannerYearProps extends HTMLAttributes<HTMLDivElement> {
	posts: PlannerPostResponse;
}

export const PlannerYear: FC<IPlannerYearProps> = ({ className, posts, ...props }) => {
	const { onMultiFiltersChange } = useFilters();
	const { selectedDate, date } = usePlannerDates();

	const postsMap = posts.results.reduce(
		(acc, post) => {
			const date = formatDate(new Date(post.published_at), 'iso') || '';
			acc[date] = [...(acc[date] || []), post];
			return acc;
		},
		{} as Record<string, PlannerPost[]>,
	);

	return (
		<div {...props} className={cn(styles.wrapper, className)}>
			<Calendar
				headerRender={() => (
					<Flex justify="center" className={styles.header}>
						{selectedDate.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' })}
					</Flex>
				)}
				value={dayjs(date)}
				fullscreen={false}
				onSelect={(value) => {
					onMultiFiltersChange(
						[EFilters.PLANNER_TYPE, EFilters.PLANNER_DATE],
						['day', formatDate(value.toDate(), 'iso')],
					);
				}}
				fullCellRender={(date) => {
					const isToday = date.format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD');

					return (
						<Flex align="center" justify="center">
							<Flex justify="center" className={cn(styles.day, { [styles.today]: isToday })}>
								{date.format('DD')}
								{postsMap[date.format('YYYY-MM-DD')]?.length > 0 && <div className={styles.dot}></div>}
							</Flex>
						</Flex>
					);
				}}
			/>
		</div>
	);
};

export default PlannerYear;
